export default "__VITE_ASSET__742fed20__"